import React from 'react';
import SubnavMobileStyled from '../../../_atoms/SubnavMobileStyled';
import SubnavItem from '@molecules/SubnavItem';

const ConnectionsMobileSubnav = () => (
    <SubnavMobileStyled>
        <SubnavItem label="My Matches" to="/my-icsc/connections/matches" exact={false} />
        <SubnavItem label="Saved Contacts" to="/my-icsc/connections/saved-contacts" />
        <SubnavItem label="Members Like Me" to="/my-icsc/connections/members-like-me" />
    </SubnavMobileStyled>
);

export default ConnectionsMobileSubnav;
